import * as type from '../../../actions/index.types'

const initialState = {
    // List
    banksData: [],
    banksPagination: null,
    loading: false,
    error: null,

    // Details
    bankDetails: null,
    detailsLoading: false,
    detailsError: null,

    // Create
    createLoading: false,
    createError: null,

    // Update
    updateLoading: false,
    updateError: null,

    // Delete
    deleteLoading: false,
    deleteError: null,

    // Journal Entries
    journalEntries: [],
    journalPagination: null,
    journalLoading: false,
    journalError: null,

    // Dropdown
    banksDropdown: [],
    banksDropdownLoading: false,
    banksDropdownError: null,
}

export const SocietyBankReducer = (state = initialState, action) => {
    switch (action.type) {
        // Get All Banks
        case type.GET_SOCIETY_BANKS:
            return { ...state, loading: true, error: null }
        case type.GET_SOCIETY_BANKS_SUCCESS:
            return {
                ...state,
                loading: false,
                banksData: action.payload?.data || [],
                banksPagination: action.payload?.meta?.pagination || null,
                error: null
            }
        case type.GET_SOCIETY_BANKS_FAILURE:
            return { ...state, loading: false, error: action.message }

        // Get Bank Details
        case type.GET_SOCIETY_BANK_DETAILS:
            return { ...state, detailsLoading: true, detailsError: null }
        case type.GET_SOCIETY_BANK_DETAILS_SUCCESS:
            return { ...state, detailsLoading: false, bankDetails: action.payload?.data || null, detailsError: null }
        case type.GET_SOCIETY_BANK_DETAILS_FAILURE:
            return { ...state, detailsLoading: false, detailsError: action.message }

        // Create Bank
        case type.CREATE_SOCIETY_BANK:
            return { ...state, createLoading: true, createError: null }
        case type.CREATE_SOCIETY_BANK_SUCCESS:
            return { ...state, createLoading: false, createError: null }
        case type.CREATE_SOCIETY_BANK_FAILURE:
            return { ...state, createLoading: false, createError: action.message }

        // Update Bank
        case type.UPDATE_SOCIETY_BANK:
            return { ...state, updateLoading: true, updateError: null }
        case type.UPDATE_SOCIETY_BANK_SUCCESS:
            return { ...state, updateLoading: false, updateError: null }
        case type.UPDATE_SOCIETY_BANK_FAILURE:
            return { ...state, updateLoading: false, updateError: action.message }

        // Delete Bank
        case type.DELETE_SOCIETY_BANK:
            return { ...state, deleteLoading: true, deleteError: null }
        case type.DELETE_SOCIETY_BANK_SUCCESS:
            return { ...state, deleteLoading: false, deleteError: null }
        case type.DELETE_SOCIETY_BANK_FAILURE:
            return { ...state, deleteLoading: false, deleteError: action.message }

        // Bank Journal Entries
        case type.GET_BANK_JOURNAL_ENTRIES:
            return { ...state, journalLoading: true, journalError: null }
        case type.GET_BANK_JOURNAL_ENTRIES_SUCCESS:
            return {
                ...state,
                journalLoading: false,
                journalEntries: action.payload?.data || [],
                journalPagination: action.payload?.meta?.pagination || null,
                journalError: null
            }
        case type.GET_BANK_JOURNAL_ENTRIES_FAILURE:
            return { ...state, journalLoading: false, journalError: action.message }

        // Banks Dropdown
        case type.GET_SOCIETY_BANKS_DROPDOWN:
            return { ...state, banksDropdownLoading: true, banksDropdownError: null }
        case type.GET_SOCIETY_BANKS_DROPDOWN_SUCCESS:
            return { ...state, banksDropdownLoading: false, banksDropdown: action.payload?.data || [], banksDropdownError: null }
        case type.GET_SOCIETY_BANKS_DROPDOWN_FAILURE:
            return { ...state, banksDropdownLoading: false, banksDropdownError: action.message }

        default:
            return state
    }
}

export default SocietyBankReducer;
